module.exports = __webpack_public_path__ + "img/EASYONOFF.c912f584.jpg";